import { studioApiClient } from '../apiClients';
import { Endpoints } from '../../network';
import { IResponse } from '../../utils/interfaces';

import { ISelfPublishingLeads } from '@/utils/interfaces/SelfPublishingLeads';

export const selfPublishingLeads = async (
  data: ISelfPublishingLeads,
): Promise<IResponse<any>> => {
  const response = await studioApiClient.post(
    `${Endpoints.selfPublishingLeads}`,
    data,
  );

  return response?.data;
};
